<template>
    <div>
        <v-tooltip bottom open-on-hover content-class="myprovet-tooltip">
            <template v-slot:activator="{ on, attrs }">
                <v-icon
                    small
                    class="appbar-icon-button-small btn-bg-color-blue"
                    :class="{
                        'red-color': product.comment,
                        'dark-blue-color': !product.comment,
                    }"
                    @click="openCommentDialog"
                    v-on="on"
                    v-bind="attrs"
                    data-cy="product-comment"
                >
                    mdi-message-reply-text-outline
                </v-icon>
            </template>
            <span>{{ $t('comment.edit') }}</span>
        </v-tooltip>

        <app-dialog :isProductComments="true" :value="isCommentDialogOpen" @input="isCommentDialogOpen = $event" :title="$t('comment.title')" width="760px">
            <template v-slot:content>
                <v-row class="d-flex flex-column">
                    <v-col cols="12">
                        <v-form ref="form" lazy-validation>
                            <v-textarea autofocus :label="$t('comment.placeholder')" v-model.trim="form.comment" :rules="[rules.message_length]" dense no-resize rows="5" data-cy="product-comment-textarea"></v-textarea>
                        </v-form>
                    </v-col>
                </v-row>
            </template>

            <template v-slot:buttons>
                <v-btn text outlined class="myprovet-btn-cancel px-8" @click="cancelComment"> {{ $t('common.cancel') }} </v-btn>

                <v-btn text v-if="form.comment" outlined class="myprovet-btn-cancel px-8" @click="clearComment" data-cy="product-comment-clear"> {{ $t('table.clear') }} </v-btn>

                <v-btn text class="myprovet-btn-ok px-8" @click="saveComment" data-cy="product-comment-save"> {{ $t('comment.save') }} </v-btn>
            </template>
        </app-dialog>
    </div>
</template>

<script>
import { i18n } from '@/i18n';
import { mapStores } from 'pinia';
import { useNormalOrderStore } from '@/Stores/normalorder';

export default {
    props: {
        product: Object,
    },

    data: () => ({
        isCommentDialogOpen: false,
        isCampaign: false,

        form: {
            comment: null,
            errors: null,
        },

        rules: {
            message_length: (value) => !value || (value && value.length <= 255) || i18n.t('comment.maxLength'),
        },
    }),

    computed: {
        ...mapStores(useNormalOrderStore),
    },

    methods: {
        isInCart(product) {
            let item = this.normalOrderStore.getProduct(product.id);

            if (product.campaign_unique_id) {
                this.isCampaign = true;

                const campaign = this.normalOrderStore.getCampaignByUniqueId(product.campaign_unique_id);
                if (!campaign) return false;

                if (!product.isOffer) {
                    const requirement = campaign.requirements.find((requirement) => requirement?.product.id === product.id);
                    if (!requirement) return false;
                    item = requirement.product;
                } else {
                    const offer = campaign.offers.find((offer) => offer?.product.id === product.id);
                    if (!offer) return false;
                    item = offer.product;
                }
            }

            return item !== undefined;
        },

        openCommentDialog() {
            if (!this.isInCart(this.product)) {
                this.showError(this.$t('comment.addToCartFirst'));
                return;
            }

            this.form.comment = this.product?.comment;
            this.isCommentDialogOpen = true;
        },

        saveComment() {
            if (!this.$refs.form.validate()) return;

            this.isCampaign //
                ? this.normalOrderStore.setCampaignProductComment(this.product, this.form.comment)
                : this.normalOrderStore.setProductComment(this.product.id, this.form.comment);
            this.cancelComment();
        },

        clearComment() {
            this.form.comment = null;
        },

        cancelComment() {
            this.isCommentDialogOpen = false;
            this.form.comment = null;
            this.isCampaign = false;
        },
    },
};
</script>
